import { EncryptionKey } from './db-fixture'
const EncryptionKeys: EncryptionKey[] = []
export default EncryptionKeys

